import React, { Component } from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { Col, Row } from 'react-bootstrap';
import LoadField from './LoadField';
import MoneyField from './MoneyField';
require(`../assets/${process.env.PAGE}/css/components/CheckSummary.css`);

class CheckSummary extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
 
        return (
                <div>
                <div className="check-summary text-center">
                    <FormattedHTMLMessage id="app.step_check_summary" description="Check summary" />
                    <div className="check-summary_line check-sumary_block"></div>
                    <div className="check-summary_details">
                        <Row className="check-summary_row summary_row_vertical_align check_amount check-sumary_block">
                            <Col className="check-summary_col text-left" xs={6} md={6} lg={6}>
                                <span>Valor nominal del cheque</span>
                            </Col>
                            <Col className="check-summary_col text-right" xs={6} md={3} lg={6}>
                                <LoadField>
                                    {this.props.summary.check_amount && (<MoneyField decimals={2}>{this.props.summary.check_amount}</MoneyField>)}
                                </LoadField>
                            </Col>
                        </Row>
                        <Row className="check-summary_row check-sumary_block">
                            <Col className="check-summary_col text-left" xs={6} md={6} lg={6}>
                                <span>Tasa</span>
                            </Col>
                            <Col className="check-summary_col text-right" xs={6} md={3} lg={6}>
                                <LoadField>
                                    {this.props.summary.rate_interest && ((this.props.summary.rate_interest * 100).toFixed(2)+ '%')}
                                </LoadField>
                            </Col>
                        </Row>
                        <Row className="check-summary_row check-sumary_block">
                            <Col className="check-summary_col text-left" xs={6} md={6} lg={6}>
                                <span>Días</span>
                            </Col>
                            <Col className="check-summary_col text-right" xs={6} md={3} lg={6}>
                                <LoadField>
                                    {this.props.summary.days_to_expiration && this.props.summary.days_to_expiration}
                                </LoadField>
                            </Col>
                        </Row>
                        <div className="check-summary_line check-sumary_block"></div>
                        <FormattedHTMLMessage id="app.step_check_summary_simulator" description="Check summary" />
                        <Row className="check-summary_row check-sumary_block">
                            <Col className="check-summary_col text-left" xs={6} md={6} lg={6}>
                                <span>Contado</span>
                            </Col>
                            <Col className="check-summary_col text-right" xs={6} md={3} lg={6}>
                                <LoadField>
                                    {this.props.summary.cash_value && (<MoneyField decimals={2}>{this.props.summary.cash_value}</MoneyField>)}
                                </LoadField>
                            </Col>
                        </Row>
                        <Row className="check-summary_row check-sumary_block">
                            <Col className="check-summary_col text-left" xs={6} md={6} lg={6}>
                                <span>Interés</span>
                            </Col>
                            <Col className="check-summary_col text-right" xs={6} md={3} lg={6}>
                                <LoadField>
                                    {this.props.summary.interest && (<MoneyField decimals={2}>{this.props.summary.interest}</MoneyField>)}
                                </LoadField>
                            </Col>
                        </Row>
                        <br/>
                        <Row className="check-summary_row check-sumary_block">
                            <Col className="check-summary_col text-left" xs={6} md={6} lg={6}>
                                <span>Derecho Mercado</span>
                            </Col>
                            <Col className="check-summary_col text-right" xs={6} md={3} lg={6}>
                                <LoadField>
                                    {this.props.summary.market_rights && (<MoneyField decimals={2}>{this.props.summary.market_rights}</MoneyField>)}
                                </LoadField>
                            </Col>
                        </Row>
                        <Row className="check-summary_row check-sumary_block">
                            <Col className="check-summary_col text-left" xs={6} md={6} lg={6}>
                                <span>IVA Derecho Mercado</span>
                            </Col>
                            <Col className="check-summary_col text-right" xs={6} md={3} lg={6}>
                                <LoadField>
                                    {this.props.summary.market_rights_iva && (<MoneyField>{this.props.summary.market_rights_iva}</MoneyField>)}
                                </LoadField>
                            </Col>
                        </Row>
                        <br/>
                        <Row className="check-summary_row check-sumary_block">
                            <Col className="check-summary_col text-left" xs={6} md={6} lg={6}>
                                <span>Comisión Agente de Bolsa</span>
                            </Col>
                            <Col className="check-summary_col text-right" xs={6} md={3} lg={6}>
                                <LoadField>
                                    {this.props.summary.brokers_stock_commission && (<MoneyField>{this.props.summary.brokers_stock_commission}</MoneyField>)}
                                </LoadField>
                            </Col>
                        </Row>
                        <Row className="check-summary_row check-sumary_block">
                            <Col className="check-summary_col text-left" xs={6} md={6} lg={6}>
                                <span>IVA Comisión</span>
                            </Col>
                            <Col className="check-summary_col text-right" xs={6} md={3} lg={6}>
                                <LoadField>
                                    {this.props.summary.brokers_stock_commission_iva && (<MoneyField>{this.props.summary.brokers_stock_commission_iva}</MoneyField>)}
                                </LoadField>
                            </Col>
                        </Row>
                        <br/>
                        <Row className="check-summary_row check-sumary_block">
                            <Col className="check-summary_col text-left" xs={6} md={6} lg={6}>
                                <span>Comisión SGR</span>
                            </Col>
                            <Col className="check-summary_col text-right" xs={6} md={3} lg={6}>
                                <LoadField>
                                    {this.props.summary.sgr_commission && (<MoneyField>{this.props.summary.sgr_commission}</MoneyField>)}
                                </LoadField>
                            </Col>
                        </Row>
                        <Row className="check-summary_row summary_row_vertical_align check-sumary_block">
                            <Col className="check-summary_col text-left" xs={6} md={6} lg={6}>
                                <span>Gastos Administrativos</span>
                            </Col>
                            <Col className="check-summary_col text-right" xs={6} md={3} lg={6}>
                                <LoadField>
                                    {this.props.summary.administrative_expenses && (<MoneyField>{this.props.summary.administrative_expenses}</MoneyField>)}
                                </LoadField>
                            </Col>
                        </Row>
                        <Row className="check-summary_row summary_row_vertical_align check-sumary_block">
                            <Col className="check-summary_col text-left" xs={6} md={6} lg={6}>
                                <span>IVA sobre gastos</span>
                            </Col>
                            <Col className="check-summary_col text-right" xs={6} md={3} lg={6}>
                                <LoadField>
                                    {this.props.summary.administrative_expenses_iva && (<MoneyField>{this.props.summary.administrative_expenses_iva}</MoneyField>)}
                                </LoadField>
                            </Col>
                        </Row>
                        <div className="check-summary_line check-sumary_block"></div>
                        <Row className="check-summary_row summary_row_vertical_align check-sumary_block check-sumary_bold">
                            <Col className="check-summary_col text-left" xs={6} md={6} lg={6}>
                                <span>Neto</span>
                            </Col>
                            <Col className="check-summary_col text-right" xs={6} md={3} lg={6}>
                                <LoadField>
                                    {this.props.summary.net_worth && (<MoneyField>{this.props.summary.net_worth}</MoneyField>)}
                                </LoadField>
                            </Col>
                        </Row>
                        <br/>
                        <Row className="check-summary_row">
                            <Col className="check-summary_col text-left" xs={12} md={12} lg={12}>
                                <p>*La presente simulación constituye una estimación no vinculante de los términos en que cada documento podrá ser negociado a través del mercado Argentino de Valores S.A. mismos, pudiendo el resultado variar en más o en menos, respecto de la simulación.</p>
                            </Col>
                        </Row>
                    </div>
                </div>

            </div>
        );
    }
}

CheckSummary.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

export default CheckSummary;


/** WEBPACK FOOTER **
 ** ./src/components/CheckSummary.js
 **/